import "core-js/modules/es.number.constructor";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import apis from '@/apis/documentApi';
import Pagination from '@/class/Pagination.model';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import Document from './Document.vue';
var paginationModel = new Pagination();

var Documents = /*#__PURE__*/function (_Vue) {
  _inherits(Documents, _Vue);

  var _super = _createSuper(Documents);

  function Documents() {
    var _this;

    _classCallCheck(this, Documents);

    _this = _super.call(this);
    _this.paginationModel = paginationModel;
    _this.documents = [];
    _this.loading = true;
    return _this;
  }

  _createClass(Documents, [{
    key: "reload",
    value: function reload(newval, old) {
      this.loading = true;
      this.getDocument(1);
    }
  }, {
    key: "getDocument",
    value: function getDocument(pageNo) {
      var _this2 = this;

      if (pageNo) {
        this.paginationModel.setPageNo(pageNo);
      }

      var endDay = this.getLastDay(this.year, this.month);
      var endDate = new Date(this.year, this.month - 1, endDay + 1);
      var startDate = new Date(this.year, this.month - 1, 2);
      var params = {
        pageNo: this.paginationModel.pageNo,
        pageSize: this.paginationModel.pageSize,
        registerTimeStart: startDate,
        registerTimeEnd: endDate
      };
      apis.getDocument(params).then(function (res) {
        _this2.documents = res.data.list || [];

        _this2.paginationModel.setTotal(res.data.total);

        _this2.loading = false;
      }).catch(function (_) {
        _this2.loading = false;
      });
    }
  }, {
    key: "getLastDay",
    value: function getLastDay(y, m) {
      var dt = new Date(y, m, 1);
      var cdt = new Date(dt.getTime() - 1000 * 60 * 60 * 24);
      return cdt.getDate();
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.paginationModel.setPageSize(pageSize);
      this.getDocument(1);
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.getDocument(pageNo);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getDocument(1);
    }
  }, {
    key: "date",
    get: function get() {
      var year = this.year,
          month = this.month;
      return {
        year: year,
        month: month
      };
    }
  }]);

  return Documents;
}(Vue);

__decorate([Prop({
  type: Number
})], Documents.prototype, "month", void 0);

__decorate([Prop({
  type: Number
})], Documents.prototype, "year", void 0);

__decorate([Watch('date')], Documents.prototype, "reload", null);

Documents = __decorate([Component({
  components: {
    Document: Document,
    EmptyContent: EmptyContent
  }
})], Documents);
export default Documents;